var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{staticClass:"text-md text-icon hover:text-icon-hover transition duration-200 cursor-pointer",attrs:{"icon":"copy"},on:{"click":_vm.copy}})}
var staticRenderFns = []

export { render, staticRenderFns }